import * as React from "react";
const SvgFiRrFork = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-fork_svg__a)">
      <path
        fill="#062147"
        d="M23.707 5.95a1 1 0 0 0-1.414 0l-5.172 5.171a3.07 3.07 0 0 1-3.4.568l6.982-6.982a1 1 0 1 0-1.414-1.414L12.3 10.286a2.98 2.98 0 0 1 .58-3.407l5.17-5.172A1 1 0 0 0 16.636.293l-5.17 5.172a5.02 5.02 0 0 0-.637 6.292L.293 22.293a1 1 0 0 0 1.414 1.414l10.536-10.536a5.02 5.02 0 0 0 6.292-.636l5.172-5.17a1 1 0 0 0 0-1.415"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-fork_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFork;
